import { render, staticRenderFns } from "./CustomSkeleton.vue?vue&type=template&id=7d10656b&scoped=true&"
import script from "./CustomSkeleton.vue?vue&type=script&lang=js&"
export * from "./CustomSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CustomSkeleton.vue?vue&type=style&index=0&id=7d10656b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10656b",
  null
  
)

export default component.exports